import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { matchPattern, parseUrl } from '../helpers/parse-url.helper';
import { MockRouteParams, MpsMockBaseService } from '../services/mps-mock.service';

@Injectable()
export class MpsMockInterceptor implements HttpInterceptor {
  constructor(private mockService: MpsMockBaseService<any>) {}

  log(...args: any[]): void {
    //console.log('[MpsMockInterceptor] ->', ...args);
  }

  /**
   * Nouvelle implémentation avec pattern matching
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const baseRoute = this.mockService.getBaseRoute();

    this.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<');
    this.log('🔍 Intercepting URL:', req.method, '@', req.url);

    // Vérifier si l'URL contient la base route
    if (!req.url.includes(baseRoute)) {
      return next.handle(req);
    }

    try {
      // Parser l'URL
      const parsedUrl = parseUrl(req.url, environment.api.host);
      this.log('📊 Parsed URL:', parsedUrl);

      // Récupérer les routes définies dans le service
      const routes = this.mockService['getRoutes']();

      // Tester chaque pattern jusqu'à trouver un match
      for (const [pattern, handler] of Object.entries(routes)) {
        // Parser le pattern pour extraire la méthode HTTP (format: "GET::/pattern" ou "/pattern")
        let httpMethod: string | null = null;
        let cleanPattern = pattern;

        if (pattern.includes('::')) {
          const [method, routePattern] = pattern.split('::');
          httpMethod = method.trim().toUpperCase();
          cleanPattern = routePattern.trim();
        }

        // Vérifier si la méthode HTTP correspond (si spécifiée dans le pattern)
        if (httpMethod && req.method !== httpMethod) {
          continue; // Skip cette route si la méthode ne correspond pas
        }

        const matchResult = matchPattern(parsedUrl, cleanPattern);

        if (matchResult.match) {
          // Construire les paramètres combinés
          const params: MockRouteParams = {
            queryParams: parsedUrl.params,
            routeParams: matchResult.params,
          };

          this.log('✅ Pattern matched:', pattern, params);

          // Exécuter le handler
          const result = handler(params, req.body);

          this.log('📤 Response:', result);

          this.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>\n\n');

          // Déterminer le code de statut approprié
          let statusCode = 200;
          if (req.method === 'POST') statusCode = 201;
          else if (req.method === 'DELETE') statusCode = 204;

          // Retourner la réponse mockée
          return of(
            new HttpResponse({
              status: statusCode,
              body: req.method === 'DELETE' ? null : result,
            })
          ).pipe(delay(300));
        }
      }

      this.log('⚠️ No pattern matched for:', parsedUrl.base_route);
    } catch (error) {
      console.error('❌ Error in mock interceptor:', error);
    }

    // Si aucun pattern ne match, laisser passer la requête
    return next.handle(req);
  }
}
